<template>
	<div>
		<div v-if="!addOrEditReady">
			<LoadingSpinner class="col-12" />
		</div>
		<div v-else>
			<div v-if="criteres_local.length > 2" class="row">
				<div class="d-none d-lg-block d-xl-block">
					<button href="#" @click="goBack()" class="btn btn-primary btn-prev mb-2"><font-awesome-icon :icon="['fal', 'long-arrow-left']" /> {{ $t('pax.retour') }}</button>
				</div>
				<div class="col mt-lg-4">
					<div class="row no-gutters align-items-center mb-3">
						<div class="col col-lg-12">
							<a href="#" @click="goBack()" class="btn btn-primary btn-retour mb-3 d-lg-none"><font-awesome-icon :icon="['fal', 'long-arrow-left']" /> {{ $t('pax.retour') }}</a>
						</div>
					</div>
					<div class="row align-items-center mb-3">
						<div class="col-3 mr-auto">
							<div class="row ml-1">
								<h3 class="mb-0 mb-lg-3">4. {{ $t('pax.comparaison') }}</h3>
								<div class="synthese w-100"><i>{{ $t('pax.comparaison_text') }}</i></div>
							</div>
						</div>
						<div :class="'col-'+col_stallion+' text-center stallion '+ getGlobalColor(callColorGrade(stallion.horse_id), colorGeneticIndicator(stallion.horse_id))" v-for="stallion in stallions_local" :key="stallion.horse_id">
							<!-- <span @click.prevent="displayDetailsCroisement(stallion.horse_id, stallion.horse_nom, stallion.horse_sire)">{{ stallion.horse_nom }}</span> -->
							<span class="stallion-pill">{{ stallion.horse_nom }}</span>
						</div>
					</div>
					<hr>
					<div class="row align-items-center">
						<div class="col-3 mr-auto synthese">
							<div v-b-toggle="'collapse-genetic'" class="row align-items-center">
								<div class="col">
									<h4>{{ $t('pax.predisposition_title') }} </h4>
									<i>{{ $t('pax.predisposition_text') }}</i>
									<div class="mt-1 text-center">
									<span class="cursor-pointer text-primary">{{ $t('pax.plus_dinfo') }}</span>
									</div>
								</div>
								<div class="col-auto">
									<font-awesome-icon :icon="['fal', 'angle-right']" />
								</div>
							</div>
						</div>
						<div :class="'col-'+col_stallion+' text-center'" v-for="stallion in stallions_local" :key="stallion.horse_id">
						<div v-b-toggle="'collapse-genetic'" :class="colorGeneticIndicator(stallion.horse_id)+' stallion cursor-pointer'">
							<div class="stallion-icon"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
						</div>

							<b-collapse :ref="'collapse-genetic'" :id="'collapse-genetic'">
								{{ $t('pax.blup_mere') }} : {{ blupFormattedMare(stallion.horse_id) }} <br>
								{{ $t('pax.blup_pere') }} : {{ blupFormattedStallion(stallion.horse_id) }}
							</b-collapse>
						</div>
					</div>
					<hr>
					<div class="row align-items-center">
						<div class="col-3 mr-auto synthese">
							<div v-b-toggle="'collapse-compatibilite'" class="row align-items-center">
								<div class="col">
									<h4>{{ $t('pax.comptabilite_title') }} </h4>
									<i>{{ $t('pax.comptabilite_text') }}</i>
									<div class="mt-1 text-center">
									<span class="cursor-pointer text-primary">{{ $t('pax.detail_ici') }}</span>
									</div>
								</div>
								<div class="col-auto">
									<font-awesome-icon :icon="['fal', 'angle-right']" />
								</div>
							</div>
						</div>
						<div :class="'col-'+col_stallion+' text-center'" v-for="stallion in stallions_local" :key="stallion.horse_id">
							<div :class="callColorGrade(stallion.horse_id)+' stallion cursor-pointer'" v-b-toggle="'collapse-compatibilite'">
								<div class="stallion-icon"><font-awesome-icon :icon="['fal', 'puzzle']"/></div>
							</div>
						</div>
					</div>
					<hr>
					<b-collapse :ref="'collapse-compatibilite'" :id="'collapse-compatibilite'">
						<div class="tabLine" v-for="critere in criteres_local" :key="critere.criteres_id">
							<div class="row no-gutters align-items-center">
								<div class="col-2 mr-auto">
									{{ critere.critereslang_label }}
								</div>
								<div :class="'col-'+col_stallion+' text-center'" v-for="stallion in stallions_local" :key="stallion.horse_id">
									<span class="bullet red" v-if="parseInt(recap[stallion.horse_id][critere.criteres_id]) < critere.criteres_red" @click.prevent="openModalGraphique(critere, stallion.horse_id)" role="button">
									</span>
									<span class="bullet green" v-else-if="parseInt(recap[stallion.horse_id][critere.criteres_id]) >= critere.criteres_green" @click.prevent="openModalGraphique(critere, stallion.horse_id)" role="button">
									</span>
									<span class="bullet orange" v-else-if="parseInt(recap[stallion.horse_id][critere.criteres_id]) >= critere.criteres_red && parseInt(recap[stallion.horse_id][critere.criteres_id]) < critere.criteres_green" @click.prevent="openModalGraphique(critere, stallion.horse_id)" role="button">
									</span>
									<span class="bullet grey" v-else></span>
								</div>
							</div>
						</div>
					</b-collapse>
					<div class="row no-gutters align-items-center my-3">
						<div class="col-3 mr-auto">
							
						</div>
				
						<div :class="'col-'+col_stallion+' text-center px-1'" v-for="stallion in stallions_local" :key="stallion.horse_id">
							<div v-if="isLg || isXl" class="row no-gutters tools mt-4 modal-pax justify-content-center">
								<!-- <div class="col-12 py-1">
									<a class="modal-btn" href="#" @click.prevent="goToPaxGraphique(stallion.horse_id)"><span><font-awesome-icon :icon="['far', 'chart-area']" /> <b>{{ $t('pax.go_to_pax_graphique') }}</b></span></a>
								</div> -->
								<!-- <div class="col-12 py-1">
									<a class="modal-btn" href="#" v-if="reload_print" @click.prevent="submitPrint(stallion)"><span>
										<font-awesome-icon v-if="stallion.processing_print" :icon="['fas', 'spinner']" pulse />
										<font-awesome-icon v-else :icon="['far', 'file-pdf']" /> 
										<b>{{ $t('pax.simulation_croisement') }}</b>
									</span></a>
								</div> -->
								<div class="col-12 py-1">
										<!-- En mode reverse, mare = l'étalon réel, stallion (dans la boucle) = une jument -->
										<a class="modal-btn light" :href="'https://www.gfeweb.com/' + lang + '/?redirect_to_fiche=1&horse_nom=' + mare.horse_nom + '&horse_sire=' + mare.horse_sire " target="_blank"><span><i>{{ mare.horse_nom }}</i><b>{{ $t('pax.voir_fiche_etalon') }}</b></span></a>
								</div>
								<div class="col-12 py-1 mt-md-2 mt-xxl-0">
									<router-link :to="{ name: 'ContractNew', params: {stallion_id: mare.horse_id, mare_id: stallion.horse_id}}" target="_blank" class="modal-btn light"><span><!--font-awesome-icon :icon="['far', 'money-check-edit']" /<!--><b>{{ $t('pax.reserver_en_ligne') }}</b></span></router-link>
								</div>
							</div>

							<button v-if="!isLg && !isXl" class="btn btn-dark rounded-pill w-100 d-block" @click.prevent="displayDetailsCroisement(stallion.horse_id, stallion.horse_nom, stallion.horse_sire)">{{ $t('pax.choisir') }}</button>
						</div>
					</div>
				</div>

				<b-modal dialog-class="modal-pax" ref="modalChoix" hide-footer>
					<template v-slot:modal-title class="d-flex">
						{{ $t('pax.detail_croisement') }}
						<span class="elipsis">{{ stallion_nom }} X {{ mare.horse_nom }}</span>
					</template>

					<template v-if="stallion_choose != null">
						<div class="tabLine" v-for="critere in criteres_local" :key="critere.criteres_id">
							<div class="row no-gutters align-items-center" >
								<div class="col-6">
									{{ critere.critereslang_label }}
								</div>
								<div class="col text-center">
									<span class="bullet red" v-if="parseInt(recap[stallion_choose][critere.criteres_id]) < critere.criteres_red">
									</span>
									<span class="bullet green" v-else-if="parseInt(recap[stallion_choose][critere.criteres_id]) >= critere.criteres_green">
									</span>
									<span class="bullet orange" v-else-if="parseInt(recap[stallion_choose][critere.criteres_id]) >= critere.criteres_red && parseInt(recap[stallion_choose][critere.criteres_id]) < critere.criteres_green">
									</span>
									<span class="bullet grey" v-else></span>
								</div>
							</div>
						</div>

						<div class="row no-gutters tools mt-4">
							<div class="col-xxl-4 col-xl-6 col-lg-4 col-md-4 col-12 px-1">
								<!-- En mode reverse : stallion_choose = ID d'une jument, mare.horse_id = ID de l'étalon réel -->
								<router-link :to="{ name: 'ContractNew', params: {stallion_id: mare.horse_id, mare_id: stallion_choose}}" target="_blank" class="modal-btn"><span><font-awesome-icon :icon="['far', 'money-check-edit']" /><b>{{ $t('pax.reserver_en_ligne') }}</b></span></router-link>
							</div>
							<div class="col-xxl-4 col-xl-6 col-lg-4 col-md-4 col-12 px-1 mt-3 mt-md-0">
								<a class="modal-btn" href="#" @click.prevent="goToPaxGraphique(stallion_choose)"><span><font-awesome-icon :icon="['far', 'chart-area']" /> <b>{{ $t('pax.go_to_pax_graphique') }}</b></span></a>
							</div>
							<!-- <div class="col-12 py-1">
								<a class="modal-btn" href="#" v-if="reload_print" @click.prevent="submitPrint(stallion)"><span>
									<font-awesome-icon v-if="stallion.processing_print" :icon="['fas', 'spinner']" pulse />
									<font-awesome-icon v-else :icon="['far', 'file-pdf']" /> 
									<b>{{ $t('pax.simulation_croisement') }}</b>
								</span></a>
							</div> -->
							<div class="col-xxl-4 col-xl-6 col-lg-4 col-md-4 col-12 px-1 mt-3 mt-md-0">
								<a class="modal-btn" :href="'https://www.gfeweb.com/' + lang + '/?redirect_to_fiche=1&horse_nom=' + stallion_nom + '&horse_sire=' + stallion_sire " target="_blank"><span><i>{{ stallion_nom }}</i><b>{{ $t('pax.voir_fiche_etalon') }}</b></span></a>
							</div>
						</div>
					</template>
				</b-modal>


			</div>
			<template v-else> 
				<p>{{ $t('pax.completer_criteres_voir_compatibilite') }}</p>
			</template>

			<b-modal dialog-class="modal-pax" ref="modal" hide-footer>
				<template v-slot:modal-title>
					{{ $t('pax.pax') }}
				</template>

				<div v-html="text_intro"></div>
			</b-modal>

			<b-modal dialog-class="modal-pax" ref="modal-graphique" size="lg" hide-footer>
				<template v-if="critere" v-slot:modal-title>
					{{ critere.critereslang_label }} - {{ mare.horse_nom }} & {{ critere.stallion_name }}
				</template>

				<div v-if="critere" class="critere paxgraphique" id="myGroup">
					<div class="position-relative">
						<div class="pax-courbe position-relative">
							<!-- Img courbe -->
							<img :src="require(`/src/assets/img/pax/legende${(critere.caracterisations.stallion + critere.caracterisations.mare) / 2}.jpg`)" :alt="'min_max_' + critere.criteres_min + '_' + critere.criteres_max">
							<!-- Img carré vert -->
							<img :src="require(`/src/assets/img/pax/zone${critere.criteres_min}${critere.criteres_max}.png`)">

							<!-- Repères des caractérisations sur l'axe des abscisses -->
							<span class="pax-repere etalon" :style="{ left: getPaxAbscisse(critere.caracterisations.stallion) }"></span>
							<span class="pax-repere jument" :style="{ left: getPaxAbscisse(critere.caracterisations.mare) }"></span>
						</div>

						<div class="row">
							<div class="col critere_lang">{{ critere.critereslang_moins }} </div>
							<div class="col text-right critere_lang">{{ critere.critereslang_plus }}</div>
						</div>
					</div>
					<div class="pax-repere-legende">
						<span class="etalon">{{ graphique_etalon.nom }} : {{ graphique_etalon.valeur / 100 }}</span>
						<span class="jument">{{ graphique_jument.nom }} : {{ graphique_jument.valeur / 100 }}</span>
					</div>
					<span v-html="$t('pax.pax_graphique_modal_text')"></span>
				</div>
			</b-modal>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Vue from 'vue'
    import { EventBus } from 'EventBus'
	import Navigation from "@/mixins/Navigation.js"
	import PaxMixin from "@/mixins/Pax.js"
	import Tools from "@/mixins/Tools.js";
	import Window from '@/mixins/Window.js'
	import _cloneDeep from 'lodash/cloneDeep';

	export default {
		name: "ResultCompatibiliteV",
		props: {
			criteres: {
				type: Array,
				default: () => ( [] )
			},
			stallions: {
				type: Array,
				default: () => ( [] )
			},
			mare: {
				type: Object,
				default: () => ( null )
			},
		},
		mixins: [Navigation, PaxMixin, Tools, Window],
		data () {
			return {
				addOrEditReady: false,
				stallions_local: [],
				criteres_local: [],
				lang: 'fr',
				stallion_choose: null,
				stallion_nom: null,
				stallion_sire: null,
				recap: {},
				text_intro: '',
				graphique_etalon: null,
				graphique_jument: null,
				reload_print: true,
				genetic_indicators: {},
				genetic_loading: false,
				compat_loading: false,
				critere: null
			}
		},
		created() {
			this.init_component()
		},
		methods: {
			async init_component() {
				this.addOrEditReady = false
				this.stallions_local = _cloneDeep(this.stallions.filter(st => st))
				this.criteres_local = _cloneDeep(this.criteres)

				this.calculCompatibilite()
				this.calculGeneticIndicator()

				this.lang = this.getConfig('lang')
				this.text_intro = this.getConfig('translations')['pax_reverse'][this.lang]

				this.addOrEditReady = true
			},

			async calculCompatibilite() {
				this.compat_loading = true
				this.recap = await this.paxCalculCompatiblite(this.stallions_local, this.criteres_local)
				this.compat_loading = false
			},

			async displayDetailsCroisement(stallion_id, stallion_nom, stallion_sire) {
				this.stallion_choose = stallion_id
				this.stallion_nom = stallion_nom
				this.stallion_sire = stallion_sire
				this.$refs["modalChoix"].show()
			},

			async goBack() {
				this.$emit("update:step_label", "mares_selected")
			},

			goToPaxGraphique(stallion_id) {
				this.$refs["modalChoix"].hide()
				this.$emit("update:stallion_id", stallion_id)
				this.$emit('update:step_label', "pax_graphique")
			},

			openIntroduction() {
				this.$refs["modalChoix"].hide()
				this.$refs["modal"].show()
			},

			async submitPrint(stallion) {
				this.setProcessingPrint(stallion.horse_id, true)
				await this.printSimulationCroisement(this.mare, stallion)
				this.setProcessingPrint(stallion.horse_id, false)
			},

			setProcessingPrint(stallion_id, value) {
				const index = this.stallions_local.findIndex(st => st.horse_id == stallion_id)
				this.reload_print = false
				this.stallions_local[index].processing_print = value
				this.$nextTick(() => {
					this.reload_print = true
				})
			},

			callColorGrade(stallion_id) {
				if(this.compat_loading) return 'genetic-loading'
				return this.colorGrade(stallion_id, this.recap, this.criteres_local)
			},

			async calculGeneticIndicator() {
				// en mode inversé, mare est l'étalon sélectionné et stallions_local les juments du client
				const mares_ids = this.stallions_local.map(mare => mare.horse_id)
				if(!this.mare || mares_ids.length == 0) return false
				this.genetic_loading = true
				this.genetic_indicators = await this.getGeneticIndicatorReverse(this.mare.horse_id, mares_ids.join(','))
				this.genetic_loading = false
			},

			colorGeneticIndicator(stallion_id) {
				if(this.genetic_loading) return 'genetic-loading'
				return Object.prototype.hasOwnProperty.call(this.genetic_indicators, stallion_id) ? this.genetic_indicators[stallion_id].genetic_indicator_color : ''
			},

			blupFormattedStallion(stallion_id) {
				const indicator = Object.prototype.hasOwnProperty.call(this.genetic_indicators, stallion_id) ? this.genetic_indicators[stallion_id] : null
				if(indicator && indicator.stallion_blup_value) {
					return `${indicator.stallion_blup_value} (${indicator.stallion_blup_cd})`
				}
				return 'N/A'
			},

			blupFormattedMare(stallion_id) {
				const indicator = Object.prototype.hasOwnProperty.call(this.genetic_indicators, stallion_id) ? this.genetic_indicators[stallion_id] : null
				if(indicator && indicator.mare_blup_value) {
					return `${indicator.mare_blup_value} (${indicator.mare_blup_cd})`
				}
				return 'N/A'
			},

			/**
			 * Ouvre la modale de la courbe de Gauss pour un critère et une jument.
			 * Calcule les caractérisations (% étalon, % jument) et les attache au critère.
			 * @param {Object} critere - Objet critère contenant `criteres_id`, seuils et libellés
			 * @param {Number} mare_id - Identifiant de la jument à afficher
			 */
			openModalGraphique(critere, mare_id) {
				// Reset à null puis réaffectation au tick suivant pour forcer le re-render
				// du composant image qui dépend de `critere.caracterisations`
				this.critere = null
				// en mode inversé, stallions_local contient les juments et `mare` l'étalon sélectionné
				const mare = this.stallions_local.find(horse => horse.horse_id == mare_id)
				const valeur_mare = mare.horse_criteres[critere.criteres_id] * 100
				const valeur_stallion = parseFloat(this.criteres_local.find(cri => cri.criteres_id == critere.criteres_id).slider) * 100
				critere.caracterisations = {
					stallion: valeur_stallion,
					mare: valeur_mare
				}
				critere.stallion_name = mare.horse_nom
				this.graphique_etalon = { nom: this.mare.horse_nom, valeur: valeur_stallion }
				this.graphique_jument = { nom: mare.horse_nom, valeur: valeur_mare }

				// détail chiffré du croisement, pour contrôler la courbe affichée
				console.log(`PAX inversé — ${critere.critereslang_label} : ${this.mare.horse_nom} X ${mare.horse_nom}`, {
					etalon: { horse_id: this.mare.horse_id, nom: this.mare.horse_nom, valeur: valeur_stallion },
					jument: { horse_id: mare.horse_id, nom: mare.horse_nom, valeur: valeur_mare },
					moyenne: (valeur_stallion + valeur_mare) / 2,
					compatibilite: this.recap[mare.horse_id] ? this.recap[mare.horse_id][critere.criteres_id] : null,
					critere: {
						criteres_id: critere.criteres_id,
						criteres_min: critere.criteres_min,
						criteres_max: critere.criteres_max,
						criteres_red: critere.criteres_red,
						criteres_green: critere.criteres_green
					}
				})

				this.$nextTick(() => {
					this.critere = critere
				})
				this.$refs["modal-graphique"].show()
			},

		},
		computed: {
			col_stallion() {
				const nb_stallions = this.stallions.length
				if(nb_stallions == 1) return 9
				if(nb_stallions == 2) return 4
				if(nb_stallions == 3) return 3
				return 3
			}
		},
		watch: {
			stallions(val) {
				this.stallions_local = _cloneDeep(val.filter(st => st))
				this.calculCompatibilite()
				this.calculGeneticIndicator()
			},
			'criteres': {
				deep: true,
				handler(val){
					this.criteres_local = _cloneDeep(val)
					this.calculCompatibilite()
					this.calculGeneticIndicator()
				}
			},
			show(val) {
				if(val) {
					window.scrollTo({ top: 250, behavior: 'smooth' });
				}
			}
		},
		components: {
			LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}
</script>
